module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_t1_b1_disable.6081ee30.svg";